export enum DoctorTitle {
  '' = '',

  'Dr. med.' = 'Dr. med.',
  'Dr. Dr. med.' = 'Dr. Dr. med.',
  'Prof. Dr. med.' = 'Prof. Dr. med.',
  'Prof. Dr. Dr. med.' = 'Prof. Dr. Dr. med.',
}